import React from 'react';
import { TextBox, TextAreaBox, CurrencyBox } from 'fw/forms';
import { Address, PhoneBox, BankingAccountTypeCombo, DocumentUpload } from "areas/shared/controls";
import { Label } from 'fw/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Col, FormGroup, Row, Button, Glyphicon } from 'react-bootstrap';
import { TooltipCode } from 'areas/shared/consts';

class BankInfoItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = props => {
        return {
            form: {
                bankAccountsList: props.bankAccountsList,
            },
            tooltips: props.tooltips,
        };
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.bankAccountsList instanceof Array) {
            this.setState({
                form: { bankAccountsList: nextProps.bankAccountsList }
            });
        }
    }

    addEmptyPhone = (index) => {
        var item = this.state.form.bankAccountsList[index];

        item.phones.push({
            phoneTypeCode: "MOBILE",
            number: "",
            extension: "",
            phoneId: -(Date.now() | 0)
        });

        return item;
    }

    findIndex = (key) => {
        return  this.state.form.bankAccountsList.findIndex(function(element) { 

            return element.entityId === key; 
        });

    }

    onChange = (key, value, field) => {
        var index = this.findIndex(key);
        var item = this.state.form.bankAccountsList[index];
        item[field] = value;

        this.props.onUpdateBankAccountsList(index, item);
    }

    handleAddPhone = (key) => {
        var index = this.findIndex(key);

        var item = this.addEmptyPhone(index);
        this.props.onUpdateBankAccountsList(index, item);
    }

    handleRemovePhone = (index, phoneIndex) => {
        var item = this.state.form.bankAccountsList[index];

        item.phones[phoneIndex].number = "";
        item.phones.splice(phoneIndex, 1);

        this.props.onUpdateBankAccountsList(index, item);
    }

    handlePhoneChange = (value, index, phoneIndex) => {
        var item = this.state.form.bankAccountsList[index];

        item.phones[phoneIndex] = value;

        this.props.onUpdateBankAccountsList(index, item);
    }

    handleReviewUpload = (formUpload, baIndex) => {
        var item = this.state.form.bankAccountsList[baIndex];
        var items = item.reviewUploads;

        var foundIndex = items.findIndex(x => x.upload.uploadKey === formUpload.upload.uploadKey);
        if (foundIndex === -1) {
            items.push(formUpload);
        }
        else {
            items[foundIndex] = formUpload;
        }

        item["reviewUploads"] = items;

        this.props.onUpdateBankAccountsList(baIndex, item);
    }

    addOtherDocument = (key) => {
        var baIndex = this.findIndex(key);

        let item = this.state.form.bankAccountsList[baIndex];
        let id = -Math.abs(Date.now() | 0);

        item.otherDocuments.push({
            bankingOtherDocumentId: id
        });

        this.props.onUpdateBankAccountsList(baIndex, item);
    };

    handleRemoveOtherDocument = (baIndex, docIndex) => {
        let item = this.state.form.bankAccountsList[baIndex];
        item.otherDocuments.splice(docIndex, 1);

        this.props.onUpdateBankAccountsList(baIndex, item);
    }

    handleDescriptionChange = (value, baIndex, docIndex) => {
        let item = this.state.form.bankAccountsList[baIndex];

        item.otherDocuments[docIndex].documentDescription = value;
        this.props.onUpdateBankAccountsList(baIndex, item);
    };

    handleOtherDocumentRemove = (baIndex, docIndex) => {
        let item = this.state.form.bankAccountsList[baIndex];

        item.otherDocuments[docIndex].documentDescription = "";
    };

    handleUploadOtherDocumentChange = (file, baIndex, index) => {
        let item = this.state.form.bankAccountsList[baIndex];

        item.otherDocuments[index].storageToken = file.storageToken;
        item.otherDocuments[index].fileName = file.fileName;

        this.props.onUpdateBankAccountsList(baIndex, item);
    };

    handleBankResolutionUploadChange = (key, value) => {
        var index = this.findIndex(key);

        var item = this.state.form.bankAccountsList[index];
        item.bankResolutionStorageToken = value.storageToken;
        item.bankResolutionFileName = value.fileName;

        this.props.onUpdateBankAccountsList(index, item);
    };

    handleBankingSignatureCardUploadChange = (key, value) => {
        var index = this.findIndex(key);

        var item = this.state.form.bankAccountsList[index];
        item.bankingSignatureCardStorageToken = value.storageToken;
        item.bankingSignatureCardFileName = value.fileName;

        this.props.onUpdateBankAccountsList(index, item);
    };

    handleCancelledChecksUploadChange = (key, value) => {
        var index = this.findIndex(key);

        var item = this.state.form.bankAccountsList[index];
        item.cancelledChecksStorageToken = value.storageToken;
        item.cancelledChecksFileName = value.fileName;

        this.props.onUpdateBankAccountsList(index, item);
    };

    renderOtherDocuments = (key) => {
        var baIndex = this.findIndex(key);

        return this.state.form.bankAccountsList[baIndex].otherDocuments.map((item, index) => (
            <Row key={item.bankingOtherDocumentId} style={{ marginBottom: 10 }}>
                <Col md={11}>
                    <DocumentUpload
                        storageToken={item.storageToken}
                        fileName={item.fileName}
                        onChange={file => this.handleUploadOtherDocumentChange(file, baIndex, index)}
                        onRemove={() => this.handleOtherDocumentRemove(baIndex, index)}
                        ref={`otherFile_${baIndex}_${index}`}
                    />
                    <TextAreaBox
                        value={item.documentDescription}
                        placeholder="Briefly describe your Uploaded Banking Document here..."
                        maxLength={500}
                        onChange={value => this.handleDescriptionChange(value, baIndex, index)}
                        required
                        ref={`otherFileDescription_${baIndex}_${index}`}
                    />
                </Col>
                <Col md={1} style={{ marginTop: 5, textAlign: "left", marginLeft: -15, paddingLeft: 0 }}>
					<Button type="button" bsStyle="link" onClick={() => this.handleRemoveOtherDocument(baIndex, index)} title="Remove Bank Document">
                        <FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
					</Button>
                </Col>
            </Row>
        ));
    };

    renderPhones = (key) => {
        var index = this.findIndex(key);

        if (this.state.form.bankAccountsList[index].phones.length === 0) {
            this.addEmptyPhone(index);
        }

        return this.state.form.bankAccountsList[index].phones.map((p, i) =>
            <div key={p.phoneId} className="form-inline" >
                <PhoneBox
                    required
                    value={p}
                    showExtension
                    onChange={(v) => this.handlePhoneChange(v, index, i)}
                    ref={`phone_${i}`}
                />
                {i > 0 ?
                    <Button
                        id="btnRemovePhone"
                        bsStyle="link"
                        title="Remove Phone"
                        onClick={() => this.handleRemovePhone(index, i)}><FontAwesomeIcon icon={faTimes} /></Button>
                    : null}
            </div>
        );
    }

    onRemoveBankAccount(key) {
        var index = this.findIndex(key);

        let me = this;

        me.props.removeBankAccount(index);
    }

    setTip = (property) => {
        const tooltip = this.state.tooltips.find(t => t.code === property)
        return tooltip !== undefined ? tooltip.tip : null
    }

    render() {
        
        let me = this;
        let rows = this.state.form.bankAccountsList.map( (item, index) => {
            return (
                <div key={item.entityId}>
                    <Row >
                        <Col md={5}>
                            <FormGroup>
                                <Label htmlFor="financialInstitution" tip={me.setTip(TooltipCode.BANKING.FINANCIALINST)} required>Financial Institution</Label>
                                <TextBox
                                    required
                                    name="financialInstitution"
                                    value={item.financialInstitution}
                                    placeholder="Financial Institution"
                                    maxLength={40}
                                    onChange={(value) => me.onChange(item.entityId, value, "financialInstitution")} />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="accountManager" tip={me.setTip(TooltipCode.BANKING.ACCOUNTMGR)} required>Account Manager</Label>
                                <TextBox
                                    required
                                    name="accountManager"
                                    value={item.accountManager}
                                    placeholder="Account Manager"
                                    maxLength={40}
                                    onChange={(value) => me.onChange(item.entityId, value, "accountManager")} />
                            </FormGroup>
                            <FormGroup>
                                <Address
                                    name={"bankAddress" + index}
                                    value={item.bankAddress}
                                    managed
                                    required
                                    onFieldChange={(value) => me.onChange(item.entityId, value, "bankAddress")} />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="phoneNumber" tip={me.setTip(TooltipCode.BANKING.PHONENUMBER)} required>Phone Number(s)</Label>
                                {me.renderPhones(item.entityId)}
                            </FormGroup>
                            {item.phones != null && item.phones.length < 5 &&
                                <FormGroup>
                                    <Button if="btnAddPhone" bsStyle="default" bsSize="xsmall" className="pull-right" onClick={() => me.handleAddPhone(item.entityId)}>Add Phone<Glyphicon glyph="plus" style={{ marginLeft: 10 }} /></Button>
                                </FormGroup>
                            }
                        </Col>
                        <Col md={1} />
                        <Col md={6}>
                            <FormGroup>
                                <Label htmlFor="bankApprovedCreditLine" tip={me.setTip(TooltipCode.BANKING.BANKAPPROVEDCL)} required>Bank Approved Credit Line</Label>
                                <CurrencyBox
                                    managed
                                    required
                                    value={item.bankApprovedCreditLine}
                                    name="bankApprovedCreditLine"
                                    placeholder="Bank Approved Credit Line"
                                    positiveNumbersOnly
                                    precision={0}
                                    onFieldChange={(value) => me.onChange(item.entityId, value, "bankApprovedCreditLine")}
                                    maxLength={10} />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="bankingAccountTypeId" tip={me.setTip(TooltipCode.BANKING.TYPEBANKACCOUNT)} required>Type of Bank Account</Label>
                                <BankingAccountTypeCombo
                                    required
                                    value={item.bankingAccountTypeId}
                                    name="bankingAccountTypeId"
                                    onChange={(value) => me.onChange(item.entityId, value.value, "bankingAccountTypeId")}
                                    placeholder="Type of Bank Account" />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="accountCorporate" tip={me.setTip(TooltipCode.BANKING.BANKACCOUNTCR)} required>Bank Account Corporate Resolution</Label>
                                <DocumentUpload
                                    storageToken={item.bankResolutionStorageToken}
                                    fileName={item.bankResolutionFileName}
                                    onChange={e => me.handleBankResolutionUploadChange(item.entityId, e)} />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="bankSignature" tip={me.setTip(TooltipCode.BANKING.BANKSIGNATURECARD)} required>Bank Signature Card(s)</Label>
                                <DocumentUpload
                                    storageToken={item.bankingSignatureCardStorageToken}
                                    fileName={item.bankingSignatureCardFileName}
                                    onChange={e => me.handleBankingSignatureCardUploadChange(item.entityId, e)} />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="cancelledChecks" tip={me.setTip(TooltipCode.BANKING.CANCELLEDCHECKS)} required>10 Cancelled Checks</Label>
                                <DocumentUpload
                                    storageToken={item.cancelledChecksStorageToken}
                                    fileName={item.cancelledChecksFileName}
                                    onChange={e => me.handleCancelledChecksUploadChange(item.entityId, e)} />
                                <span className="small">Please combine into 1 Document - Images must include a visible signature</span>
                            </FormGroup>
                            <FormGroup>
                                {item.otherDocuments != null && item.otherDocuments.length > 0 && (
                                    <React.Fragment>
                                        {me.renderOtherDocuments(item.entityId)}
                                    </React.Fragment>
                                )}
                                {(item.otherDocuments == null || item.otherDocuments.length < 5) &&
									<Button type="button" bsStyle="link" onClick={() => me.addOtherDocument(item.entityId)}>
										Add another Bank Document
									</Button>
								}
                            </FormGroup>
                            <input type="hidden" name="rowVersion" value={item.rowVersion} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <FormGroup>
                                <br /><br />
                                {index === me.state.form.bankAccountsList.length - 1 ? (
                                    <Button id="addBankAccount" bsSize='xsmall' onClick={() => me.props.addBankAccount(me.state.form.bankAccountsList.length)}>Add another Bank Account</Button>
                                ) : null}
                                &nbsp;&nbsp;
                        {index > 0 ? (
                                    <Button id="removeBankAccount" bsSize='xsmall' onClick={() => me.onRemoveBankAccount(item.entityId)}>Remove Bank Account</Button>
                                ) : null}
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
            );
        });
        return <React.Fragment>{rows}</React.Fragment>;
    }

}

export default BankInfoItem;


// WEBPACK FOOTER //
// ./src/areas/certification/steps/bankInfo/BankInfoItem.js